import { render, staticRenderFns } from "./EmployeeList.vue?vue&type=template&id=1f54151f&"
import script from "./EmployeeList.vue?vue&type=script&lang=js&"
export * from "./EmployeeList.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeList.vue?vue&type=style&index=0&id=1f54151f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports